exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2dqiP{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;padding-right:12px;padding-top:10px;margin-top:-10px;-webkit-transition:all ease-auto .1s;-o-transition:all .1s ease-auto;transition:all ease-auto .1s}._2zkrB{height:40px;overflow:hidden}._17D3k{display:block;position:absolute;right:-4px;top:10px;width:24px;height:24px;margin:3px 0 0;text-align:center}._17D3k img{-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}._2zkrB ._17D3k img{-webkit-transform:rotate(180deg);transform:rotate(180deg)}", ""]);

// exports
exports.locals = {
	"root": "_2dqiP",
	"collapsed": "_2zkrB",
	"arrow": "_17D3k"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/SearchPanel/ColorsForm/ColorsForm.css
// module id = 1984
// module chunks = 0 1 15 17